"use client";

import { cn } from "@klarify/ui/lib/utils";
import * as LabelPrimitive from "@radix-ui/react-label";
import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";
import type * as React from "react";

const labelVariants = cva(
	"font-normal text-klarify-neutral-800 text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
);

type LabelProps = React.ComponentProps<typeof LabelPrimitive.Root> &
	VariantProps<typeof labelVariants> & {
		/** Appends a visual asterisk. Put `required` on the control itself for assistive tech. */
		required?: boolean;
	};

const Label = ({
	ref,
	className,
	required,
	children,
	...props
}: LabelProps) => (
	<LabelPrimitive.Root
		ref={ref}
		className={cn(labelVariants(), className)}
		{...props}
	>
		{children}
		{required && (
			<span
				aria-hidden="true"
				className="ml-0.5 text-destructive"
			>
				*
			</span>
		)}
	</LabelPrimitive.Root>
);
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
